import { Component, ElementRef, HostListener } from '@angular/core';
import { ModalService } from '../services/modal/modal.service';
import { firstValueFrom } from 'rxjs';

@Component({
  selector: 'app-modal-dialog',
  templateUrl: './modal-dialog.component.html',
  styleUrls: ['./modal-dialog.component.scss']
})
export class ModalDialogComponent {
  constructor(
    private readonly _elementRef: ElementRef,
    readonly modalService: ModalService
  ) {}

  @HostListener('document:click', ['$event'])
  private onDocumentClick(event: MouseEvent) {
    setTimeout(async () => {
      // Return if the component is not visible
      const visible = await firstValueFrom(this.modalService.state$);
      if (!visible) return;
      // Return for clicks inside the component
      const target = event.target as HTMLElement;
      const shouldStayOpen = target.closest('.app-modal-content');
      if (shouldStayOpen) return;
      // Close the modal otherwise
      this.modalService.close();
    });
  }
}
